import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "pdf-viewer-page" }
const _hoisted_2 = {
  key: 0,
  class: "loading-tip"
}
const _hoisted_3 = { class: "bottom-actions" }

import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { showToast } from 'vant'
import { isInApp, isInHostMiniAppWebView } from '@h5-journey/utils'
import NavBar from './Navbar.vue'
import BottomFixed from '../layout/BottomFixed.vue'
import { usePdfh5Renderer, downloadFile, goBack, copyToClipboard } from '@h5-journey/utils'
import 'pdfh5/css/pdfh5.css'

interface Props {
  /** PDF 文件地址 */
  filePath: string
  /** 标题，默认“电子收据预览” */
  title?: string
  /** 加载中提示，默认“加载中...” */
  loadingText?: string
  /** 下载按钮文字，默认“下载” */
  downloadText?: string
  /** 复制链接按钮文字，默认“复制链接” */
  copyText?: string
  /** 复制成功提示，默认“复制链接成功” */
  copySuccessText?: string
  /** 是否显示底部操作区（下载/复制链接），默认显示 */
  showActions?: boolean
}

const containerId = 'shared-pdf-viewer'

export default /*@__PURE__*/_defineComponent({
  __name: 'PdfViewer',
  props: {
    filePath: {},
    title: { default: '电子收据预览' },
    loadingText: { default: '加载中...' },
    downloadText: { default: '下载' },
    copyText: { default: '复制链接' },
    copySuccessText: { default: '复制链接成功' },
    showActions: { type: Boolean, default: true }
  },
  setup(__props: any) {

const props = __props

const router = useRouter()

// 宿主适配（2026-10-22）：小程序/元服务宿主原生导航占用顶部、真实 APP 原生 WebView 自带标题栏，
// 两类宿主隐藏自绘导航以免双标题；普通浏览器保留自绘导航（内置返回）。路由 meta.title 与
// query.title 可能不一致（如「文件预览」/「电子保单」），document.title 以文档标题为准同步，
// 供宿主原生标题栏展示
const hideNavBar = isInHostMiniAppWebView() || isInApp()

onMounted(() => {
  document.title = props.title
})

const { loading } = usePdfh5Renderer({
  selector: `#${containerId}`,
  pdfurl: props.filePath,
  scalable: true
})

const downloadFilename = computed(() => {
  return `${props.title}.pdf`
})

const handleDownload = async () => {
  try {
    await downloadFile(props.filePath, downloadFilename.value)
  } catch (error) {
    console.error('下载失败', error)
  }
}

const handleCopy = async () => {
  try {
    await copyToClipboard(props.filePath)
    showToast(props.copySuccessText)
  } catch (error) {
    console.error('复制失败', error)
  }
}

const handleBack = () => {
  if (router.options.history.state.back) {
    router.back()
  } else {
    goBack()
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(hideNavBar))
      ? (_openBlock(), _createBlock(NavBar, {
          key: 0,
          title: _ctx.title,
          fixed: false,
          onClickLeft: handleBack
        }, null, 8, ["title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["pdf-content", { 'no-actions': !_ctx.showActions }])
    }, [
      _createElementVNode("div", {
        id: containerId,
        class: "pdf-container"
      }),
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.loadingText), 1))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.showActions)
      ? (_openBlock(), _createBlock(BottomFixed, { key: 1 }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("button", {
                class: "download-btn",
                onClick: handleDownload
              }, _toDisplayString(_ctx.downloadText), 1),
              _createElementVNode("button", {
                class: "copy-btn",
                onClick: handleCopy
              }, _toDisplayString(_ctx.copyText), 1)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})